/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';
import template from './setup-organization.html';

export default {
  name: 'SetupOrganization',
  template,
  components: { SetupHeader },
  directives: { focus },
  methods: {
    onBack() {
      this.$emit('back');
    },
    onSubmit(organization) {
      this.$emit('submit', organization);
    }
  },
  props: ['isOnline', 'organizationArray']
};
